module.exports = __webpack_public_path__ + "static/icons/icon-eyeball-reporter-fc44a2272862ed2cf88d09765f1e1702.svg";